import dayjs from '@/plugins/dayjs';

export default {
  methods: {
    formatDate(date) {
      return dayjs(date).format('DD/MM/YYYY');
    },
  },
};
